<template>
    <section class="flex md:flex-col">
        <section>
            <AdminDashboardNav/>
        </section>
        <section class="font-poppins w-screen pr-5 pl-5 p-2 md:p-1 md:pr-1">    
            <section class="mt-6">
                <div class=" flex justify-between md:flex-col-reverse">
                    <div class="md:mt-6">
                        <GetDate/>
                        <p class="text-blue-700 font-bold text-2xl md:text-sm">MANAGE USERS</p>
                    </div>

                    <div class=" mr-10">
                        <Notification/>
                    </div>
                </div>
            </section>
            <div>
                <UsersList/>
            </div>
            
        </section>
    </section>
</template>

<script>
import UsersList from './UsersList.vue'; 
import GetDate from '../GetDate.vue';
import Notification from '../Notification.vue';
import AdminDashboardNav from '../AdminDashboardNav.vue'
export default {
    components : {
        AdminDashboardNav,
        UsersList,
        GetDate,
        Notification
    },
    data() {
        return {
            
        }
    },

    mounted() {
        this.networkError()
    },

    methods: {
        networkError() {
            if(!navigator.onLine) {
                this.$router.push('/network-error')
            } 
        }
    }
}
</script>